module.exports = __webpack_public_path__ + "aded20c1669c2a666e6a1fc1b7349091.pdf";